import { Link } from 'react-router-dom';

const footerLinks = {
  Collections: [
    { label: 'Nordic Calm', path: '/collections' },
    { label: 'Terra Luxe', path: '/collections' },
    { label: 'Wabi-Sabi', path: '/collections' },
    { label: 'Modern Classic', path: '/collections' },
  ],
  Products: [
    { label: 'Sofas', path: '/products' },
    { label: 'Tables', path: '/products' },
    { label: 'Chairs', path: '/products' },
    { label: 'Lighting', path: '/products' },
  ],
  Company: [
    { label: 'About Us', path: '/about' },
    { label: 'Craftsmanship', path: '/about' },
    { label: 'Sustainability', path: '/about' },
    { label: 'Careers', path: '/about' },
  ],
  Support: [
    { label: 'Contact Us', path: '/contact' },
    { label: 'Book a Visit', path: '/contact' },
    { label: 'Delivery & Returns', path: '/contact' },
    { label: 'Care Guide', path: '/contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#2c2420] text-white">
      <div className="w-full px-8 md:px-16 pt-16 pb-8">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row gap-12 mb-14">
          {/* Brand Side */}
          <div className="w-full lg:w-[340px] flex-shrink-0">
            <div className="flex flex-col leading-none mb-6">
              <span
                className="text-2xl font-bold tracking-tight text-white"
                style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '0.04em' }}
              >
                RETAILFLOW
              </span>
              <span className="text-xs font-medium tracking-[0.25em] uppercase text-[#c4a882] mt-0.5">
                LLC
              </span>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-5">
              Your trusted partner for premium furniture solutions. We deliver quality craftsmanship and timeless design to homes and businesses across the United States.
            </p>
            <div className="space-y-2.5 mb-6">
              <div className="flex items-start gap-2.5">
                <i className="ri-map-pin-2-line text-[#8B6348] text-sm mt-0.5 flex-shrink-0" />
                <p className="text-stone-400 text-xs leading-relaxed">
                  4131 W Morten Ave, Phoenix, AZ 85051
                </p>
              </div>
              <div className="flex items-start gap-2.5">
                <i className="ri-id-card-line text-[#8B6348] text-sm mt-0.5 flex-shrink-0" />
                <p className="text-stone-400 text-xs leading-relaxed">
                  EIN: 41-3974436
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              {['ri-instagram-line', 'ri-pinterest-line', 'ri-facebook-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-[#8B6348] hover:text-[#8B6348] transition-all duration-200 cursor-pointer"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Links Grid */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category}>
                <h4 className="text-xs uppercase tracking-widest text-stone-400 mb-4 font-medium">
                  <a href="#">{category}</a>
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-stone-300 hover:text-white transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">
            &copy; {new Date().getFullYear()} RETAILFLOW LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-stone-500 text-xs hover:text-stone-300 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="text-stone-500 text-xs hover:text-stone-300 transition-colors cursor-pointer">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
